import artist from './artist.js';
/**
 * generate langPrefix to all route
 * all route name must be unique
 *
 * @param {Array} routes{path, name, components}
 * @returns {Array}
 */
/*
function langPrefix(routes) {
  const langPrefixPages = [];
  routes.forEach((r) => {
    const n = Object.assign({}, r);
    n.path = `/:lang${r.path}`;
    n.name = `lang-${r.name}`;
    langPrefixPages.push(n);
  });
  return langPrefixPages;
}
*/

const languageRegex = process.env.VUE_APP_LANGUAGE_CODES.split(',').join('|');

export default [
  ...artist,
  {
    path: `/:lang(${languageRegex})?/*`,
    name: 'not-found',
    component: () => import(/* webpackChunkName: "not-found" */ '@motionelements/core/src/components/NotFound.vue'),
  },
];
